import { useNavigate } from "react-router-dom";

const StatsCard = ({ title, value, className, onClick }) => {
  return (
    <div
      style={{
        boxShadow: "0px 1.5px 27.6px 0px #E1D8FFC4",
      }}
      className={`relative overflow-hidden border-l-4 border-[#4F22D857] hover:border-[#4F22D8] rounded-2xl p-1 py-4 transition-all duration-300 cursor-pointer group bg-[#FFFFFF] text-black ${
        className || ""
      }`}
      onClick={onClick}
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 z-0">
        <div
          className="w-full h-full"
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, #7346FD 0%, #4F22D8 100%)",
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center">
        <h3 className="text-base font-bold mb-2 text-black group-hover:text-white transition-colors duration-300">
          {title}
        </h3>
        <p className="text-xl font-bold text-black group-hover:text-white transition-colors duration-300">
          {value}
        </p>
      </div>
    </div>
  );
};

const StatsGrid = ({ memberStatistics }) => {
  const navigate = useNavigate(); // Add navigation hook

  // Handle loading state
  if (!memberStatistics) {
    return (
      <div className="pb-0 py-8">
        <div className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {Array(4)
              .fill(0)
              .map((_, index) => (
                <div key={index} className="animate-pulse">
                  <div className="bg-gray-300 h-32 rounded-2xl"></div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }

  const handleCardClick = (cardType) => {
    let queryParams = "";

    switch (cardType) {
      case "founder":
        queryParams = "?memberRole=Founder Member";
        break;
      case "total":
        queryParams = "";
        break;
      case "officeBearers":
        queryParams = "?isCurrentOfficeBearer=true";
        break;
      case "lifetime":
        queryParams = "?memberRole=Lifetime Member";
        break;
      default:
        queryParams = "";
    }

    navigate(`/admin/members/list${queryParams}`);
  };

  const stats = [
    {
      title: "Founder Members",
      value: memberStatistics.founderMembers || 0,
      cardType: "founder",
    },
    {
      title: "Total Members",
      value: memberStatistics.totalMembers || 0,
      cardType: "total",
    },
    {
      title: "Current Office Bearers",
      value: memberStatistics.currentOfficeBearers || 0,
      cardType: "officeBearers",
    },
    {
      title: "Lifetime Members",
      value: memberStatistics.lifetimeMembers || 0,
      cardType: "lifetime",
    },
  ];

  return (
    <div className="pb-0 py-8">
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6 mb-8">
          {stats.map((stat, index) => (
            <StatsCard
              key={index}
              title={stat.title}
              value={stat.value}
              onClick={() => handleCardClick(stat.cardType)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsGrid;
